import React from 'react';
import { Button } from 'antd';
import { ProfileDetails } from './components/ProfileDetails';
import Chat from '../../assets/images/png/chat.png';
import { Link } from 'react-router-dom';

export interface GuestProps {
  userdetails: any;
}

export const Guest: React.FC<GuestProps> = ({ userdetails }) => {
  return (
    <div className="chat-container">
      <ProfileDetails details={userdetails} />
      <div className="chat-content">
        <Link
          to={{
            pathname: '../chat/:',
            state: { user: userdetails, chatid: '' },
          }}
        >
          <Button
            shape="circle"
            icon={<img src={Chat} alt="chat" />}
            size="large"
          />
        </Link>
      </div>
    </div>
  );
};
